var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptionSelector',{attrs:{"model":'state',"nextRoute":item => (item.is_station ? 'StationPage' : 'RegionPage')}})
}
var staticRenderFns = []

export { render, staticRenderFns }